var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgTag = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m13.972 9.468-4.504 4.504a1.219 1.219 0 0 1-.862.361 1.21 1.21 0 0 1-.859-.361L2.018 8.249c-.114-.11-.2-.238-.261-.385a1.217 1.217 0 0 1-.09-.465v-4.52c0-.334.117-.62.353-.856.235-.238.521-.356.858-.356h4.52a1.252 1.252 0 0 1 .86.361l5.714 5.723c.122.121.211.258.267.409a1.253 1.253 0 0 1 0 .905 1.141 1.141 0 0 1-.267.403Zm-5.217 3.801 4.504-4.504a.206.206 0 0 0 .064-.15.206.206 0 0 0-.064-.15L7.472 2.672H2.878a.21.21 0 0 0-.15.058.194.194 0 0 0-.061.147v4.51a.24.24 0 0 0 .012.077.18.18 0 0 0 .045.07l5.73 5.734a.206.206 0 0 0 .15.064.206.206 0 0 0 .151-.064ZM4.35 5.186c.232 0 .43-.081.592-.243a.803.803 0 0 0 .244-.59.813.813 0 0 0-.243-.595.8.8 0 0 0-.59-.245.81.81 0 0 0-.595.244.806.806 0 0 0-.245.593c0 .232.081.43.244.592.163.163.36.244.593.244Z",
  fill: "currentColor"
})));

export default SvgTag;